export type IOwnershipFilter = 'all' | 'yours' | 'vendors';

export const OWNERSHIP_FILTER_OPTIONS: Array<{ value: IOwnershipFilter; label: string }> = [
  { value: 'all', label: 'All applications' },
  { value: 'yours', label: 'Your applications' },
  { value: 'vendors', label: 'Vendor applications' },
];

const OWNED_BY_FILTER: Record<IOwnershipFilter, boolean | undefined> = {
  all: undefined,
  yours: true,
  vendors: false,
};

export const getOwnedVariable = (filter: IOwnershipFilter) => {
  const owned = OWNED_BY_FILTER[filter];

  return owned === undefined ? {} : { owned };
};
